import { Plot } from '@/api/rest/resources/types/plot';
import { buildPath } from '@/utils/buildPath';

type PlotEditPathSet = {
  editPlot: string;
  editPlotOrg: string;
};

export const buildPlotEditPath = (plot: Pick<Plot, 'id' | 'project' | 'project_id'>, pathSet: PlotEditPathSet) => {
  const projectId = plot.project ?? plot.project_id;

  if (!projectId) {
    return buildPath(pathSet.editPlotOrg, { pathParams: { plotId: plot.id } });
  }

  return buildPath(pathSet.editPlot, { pathParams: { projectId, plotId: plot.id } });
};
